import { Box, Button, Dialog, Typography } from "@mui/material";
import { ROUTES } from "constants/routes";
import { useNavigate } from "react-router-dom";

const BookingSuccessModal = () => {
  const navigate = useNavigate();
  return (
    <Dialog open fullWidth maxWidth="sm">
      <Box
        sx={{
          backgroundImage: "url(/assets/img/success_celeb.png)",
          height: "460px",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",

          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          gap="26px"
          sx={{
            img: {
              height: {
                sm: "72px",
                xs: "72px",
                md: "104px",
                lg: "104px",
                xl: "104px",
              },
            },
            mb: "22px",
          }}
        >
          <img src="/assets/img/successful_check.png" alt="" />
          <Typography
            sx={{
              color: "#323232",
              fontSize: {
                sm: "18px",
                xs: "18px",
                md: "26px",
                lg: "26px",
                xl: "26px",
              },
              fontWeight: 700,
              lineHeight: "22px",
              textAlign: "center",
            }}
          >
            Congratulations!{" "}
          </Typography>
          <Typography
            sx={{
              color: "#A2A2A2",
              fontSize: "16px",
              fontWeight: 500,
              lineHeight: "22px",
              textAlign: "center",
              px: "20px",
            }}
          >
            Your request has been successfully sent to the owner. Keep an eye on
            your email and explore personal rental options for exciting details
            ahead!
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: {
                md: "row",
                lg: "row",
                xl: "row",
                sm: "column",
                xs: "column",
              },
              gap: "15px",
              //   flexWrap: {
              //     md: "no-wrap",
              //     lg: "no-wrap",
              //     xl: "no-wrap",
              //     sm: "wrap",
              //     xs: "wrap",
              //   },
              px: "20px",
              width: "90%",
            }}
          >
            <Button
              sx={{ height: "56px", padding: 0, borderRadius: "10px" }}
              fullWidth
              variant="outlined"
              onClick={() => navigate(ROUTES.HOME)}
            >
              Go to Home
            </Button>
            <Button
              sx={{ height: "56px", padding: 0, borderRadius: "10px" }}
              fullWidth
              variant="contained"
              onClick={() => navigate(ROUTES.PERSONAL_RENTAL)}
            >
              Explore Personal Rental
            </Button>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BookingSuccessModal;
